export { MiniGameCoreModule } from './mini-game-core.module';
export { MiniGameSelectorComponent } from './mini-game-selector/mini-game-selector.component';
export { MiniGameCoreService } from './mini-game-core.service';
export { IMiniGame } from './mini-game.interface';
